<template>
    <div class="container w-100" style="max-width: 100%">
        <h1>Nahlásené poruchy</h1>

        <div class="row">
            <div class="col-md-3">
                <v-select
                    :items="[...solutionsOptions, ...{text: 'Všetky',value: ''}]"
                    v-model="solutionFilter"
                    label="Riešenia"
                ></v-select>
            </div>
            <div class="col-md-2">
                <v-select
                    :items="[...typeOptions, ...{text: 'Všetky',value: ''}]"
                    v-model="typeFilter"
                    label="Štádium riešenia"
                ></v-select>
            </div>
            <div class="col-md-2">
                <v-select
                    :items="[...userOptions, ...{text: 'Všetky',value: ''}]"
                    v-model="userFilter"
                    label="Zodpovedý"
                ></v-select>
            </div>
            <div class="col-md-3">
                <v-text-field
                    v-model="search"
                    label="Vyhľadávanie"
                    single-line
                    hide-details
                ></v-text-field>
            </div>

            <div class="col-md-2 text-right">
                <button class="btn btn-success mt-2" v-on:click="this.export"><font-awesome-icon :icon="['fas', 'file-export']" /> Export XLSX</button>
            </div>

        </div>

        <v-data-table
            :headers="headers"
            :items="defects"
            :items-per-page="20"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 50]
            }"
            :search="search"
            class="elevation-1"
            loading
            loading-text="Načítavam..."
            @current-items="getFiltered"
            :disable-pagination="disablePagination"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
        >
            <template v-slot:item.point.name="{ item }">
                <router-link
                    :to="{
                        name: 'dashboard',
                        params: {
                            mapType: 'defect',
                            point: item.point.name.replace('/', '')
                        }
                    }"
                    class="btn btn-link"
                >
                    {{ item.point.name }}
                </router-link>
            </template>

            <template v-slot:item.created_at="{ item }">
                <span>{{
                    item.created_at | moment("DD.MM.YYYY HH:mm:ss")
                }}</span>
            </template>


            <template v-slot:item.solutions_check="{ item }">
                <span
                    class="text-success"
                    v-if="item.solutions_check == 'solved'"
                ><font-awesome-icon
                    :icon="['fas', 'check']"
                    title="Vyriešené"
                /></span>
                <span
                    class="text-danger"
                    v-if="item.solutions_check == 'unsolved'"
                ><font-awesome-icon
                    :icon="['fas', 'times']"
                    title="Nevyriešené"
                /></span>
                <span
                    class="text-warning"
                    v-if="item.solutions_check == 'processed'"
                >
                    <font-awesome-icon
                        :icon="['fas', 'minus-circle']"
                        title="V procese"
                    /></span>
            </template>

            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ name: 'defectsEdit', params: { id: item.id } }"
                    class="btn btn-outline-primary btn-sm"
                >
                    <font-awesome-icon :icon="['fas', 'edit']" />
                </router-link>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import api from "../../store/api";
import {json2excel, excel2json} from 'js2excel';
import { FETCH_DEFECT_SOLUTIONS } from "@/vuex/modules/actions.type"
import { mapGetters } from "vuex"
import { DefectTypesService } from "@/common/defectTypes.service"
import { UserService } from "@/common/user.service"

export default {
    name: "Defects",
    data() {
        return {
            slots: [
                {
                    text: "Vyriešené",
                    value: "solved"
                },
                {
                    text: "Nevyriešené",
                    value: "unsolved"
                },
                {
                    text: "V procese",
                    value: "processed"
                },
                {
                    text: "Všetky",
                    value: ""
                }
            ],
            search: "",
            defects: [],
            solutionFilter: "",
            typeFilter: "",
            typeOptions: [],
            userFilter: "",
            userOptions: [],
            sortBy: 'created_at',
            sortDesc: true,
            disablePagination: false,
            currentItems: [],
        };
    },
    mounted() {
        api.get(`/reported`)
            .then(response => {
                this.defects = response.data;
            })
            .catch(error => {
                alert(error);
            });

        DefectTypesService.query()
            .then(resp => {
                this.typeOptions = resp.data
            })
            .catch(err => {
                console.log(err);
            });

        UserService.list()
            .then(resp => {
                this.userOptions = resp.data
            })
            .catch(err => {
                console.log(err);
            });
        this.fetchDefectSolutions();
    },
    methods: {
        fetchDefectSolutions() {
            this.$store.dispatch(FETCH_DEFECT_SOLUTIONS);
        },
        getFiltered(e) {
            this.currentItems = e;
        },
        async export() {
            this.disablePagination = true;
            await new Promise(r => setTimeout(r, 500));

            let data = this.currentItems.map(item => {
                item;
                return {
                    "Svetelny bod": item.point.name,
                    'Popis': item.note,
                    'Dátum nahlásenia': item.created_at,
                    'Riešenie': item.solutions_plain,
                    'Typ': item.defect_type ? item.defect_type.name : '',
                    'Zodpovedný': item.user ? item.user.name : '',
                    'Doba riešenia': item.solution_length,
                };
            });

            try {
                json2excel({
                    data,
                    name: 'nahlasene-poruchy',
                    formateDate: 'yyyy/mm/dd'
                });
            } catch (e) {
                console.error('export error');
            }

            // this.disablePagination = true;
            // await new Promise(r => setTimeout(r, 500));
            // const dataToExcel1 = this.currentItems.map(item => {
            //     return {
            //         // "Svetelny_bod": item.point.name,
            //         // 'Popis': item.note,
            //         'Popis': 'sdf',
            //         // 'Dátum nahlásenia': item.created_at,
            //         // 'Riešenie': item.created_at,
            //         // 'Typ': item.created_at,
            //         // 'Zodpovedný': item.created_at,
            //         // 'Doba rišenia': item.created_at,
            //     };
            // });

            // let dataToExcel = [
            //     {
            //         "userId": 1,
            //         "userPhoneNumber": 1888888888,
            //         "userAddress": 'xxxx',
            //         "date": '2013/09/10 09:10'  // string
            //     },
            //     {
            //         "userId": 2,
            //         "userPhoneNumber": 1888888888,
            //         "userAddress": 'xxxx',
            //         "date": new Date()
            //     },
            //     {
            //         "userId": 3,
            //         "userPhoneNumber": 1888888888,
            //         "userAddress": 'xxxx',
            //         "date": new Date()
            //     }
            // ];
            // try {
            //     json2excel({
            //         dataToExcel,
            //         name: 'nahlasene-poruchy',
            //         formateDate: 'yyyy/mm/dd'
            //     });
            // } catch (e) {
            //     console.error('export error');
            // }

            this.disablePagination = false;
        }
    },
    computed: {
        ...mapGetters({
            solutionsOptions: "allSolutions",
            isLoading: "isLoading"
        }),
        headers() {
            return [
                {
                    text: "Svetelný bod",
                    align: "left",
                    sortable: false,
                    value: "point.name"
                },
                { text: "Popis", value: "note", width: 500 },
                { text: "Dátum nahlásenia", value: "created_at", width: 160 },
                // { text: "Dátum nahlásenia", value: "created_at", align: ' d-none' },
                { text: "Riešenie", value: "solutions_plain", width: 300,
                    filter: value => {
                        if (this.solutionFilter === "") return true;
                        let filtered = this.solutionsOptions.filter((val) => {
                            return val.value == this.solutionFilter
                        });

                        return value.includes(filtered[0].text);
                    }
                },
                {
                    text: "Typ",
                    value: "defect_type.name",
                    width: 100,
                    filter: (value) => {
                        if (this.typeFilter === "") return true;
                        let filtered = this.typeOptions.filter((val) => {
                            return val.value == this.typeFilter
                        });

                        return filtered.length && value == filtered[0].text;
                    }
                },{
                    text: "Zodpovedný",
                    value: "user.name",
                    width: 100,
                    filter: (value) => {
                        if (this.userFilter === "") return true;
                        let filtered = this.userOptions.filter((val) => {
                            return val.value == this.userFilter
                        });

                        return filtered.length && value == filtered[0].text;
                    }
                },{
                    text: "Doba riešenia",
                    value: "solution_length",
                    width: 120
                },
                {
                    text: "Vyriešené",
                    value: "solutions_check",
                },
                { text: "", value: "action", sortable: false }
            ];
        }
    }
};
</script>

<style scoped>
.material-icons {
    display: none;
}
</style>
